module.exports = __webpack_public_path__ + "static/media/users-solid.49be2bea.svg";